import styled from '@emotion/styled';
import React from 'react';
import { Typography } from './Typography';
import logo from '../../../../../assets/img/logo/logo1.png';
import logoNoText from '../../../../../assets/img/logo/logoNoText.png';
import { Link } from 'react-router-dom';
interface SidebarHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  rtl: boolean;
  collapsed:boolean;
}


const StyledSidebarHeader = styled.div`
  height: 64px;
  min-height: 64px;
  display: flex;
  align-items: center;
 

  > div {
    width: 100%;
    overflow: hidden;
  }
`;



export const SidebarHeader: React.FC<SidebarHeaderProps> = ({ children, collapsed, rtl, ...rest }) => {
  return (
    <StyledSidebarHeader {...rest}>
   {collapsed ?
        <div style={{ display: 'flex', alignItems: 'center', paddingTop: '0px', paddingLeft: '25px' }}>
          <Link to="/home/get-started">
            <img src={logoNoText} width={25} alt="Logo" />
          </Link>
        </div> :
        <div style={{ display: 'flex', alignItems: 'center', paddingTop: '10px', paddingLeft: '25px' }}>
          <Link to="/home/get-started">
            <img src={logo} width={140} alt="Logo" />
          </Link>
        </div>
      }
    </StyledSidebarHeader>
  );
};
